const idle = {
  // w : ['keydown', 'mousedown', 'mousemove', 'touchstart'],
  w : ['keydown', 'wheel', 'mousedown', 'touchstart'],
  f : undefined, // callback function (timeout)
  e : undefined, // expire at (reset when user action)
  t : undefined, // ttl (timeout)
  r : undefined, // reset event handler
  p : false, // pause
  s : false, // stop
  k : undefined, // keepalive function
  h : { w:undefined, k:undefined }, // timeout handler
  reset: () => { idle.e = new Date().getTime(); },
  watch: () => {
    if(idle.p) { setTimeout(() => idle.watch(), 1000); return }
    if(idle.e < new Date().getTime() - idle.t) { idle.stop(); idle.f && idle.f(); } else { idle.h.w = setTimeout(() => idle.watch(), 1000); }
  },
  start: (timeout_cb, ttl_min = 5) => {
    console.log('[svc] idle', 'start');
    idle.w.forEach(e => window.removeEventListener(e, idle.r)); // 기존 이벤트 삭제
    clearTimeout(idle.h.w);
    clearTimeout(idle.h.k);

    idle.e = new Date().getTime();
    idle.t = ttl_min * 60000;
    idle.f = timeout_cb;
    idle.s = false;
    idle.r = idle.reset.bind(idle);
    idle.w.forEach(e => window.addEventListener(e, idle.r));
    idle.watch();
    return idle;
  },
  get stale() { return idle.p ? Number.MAX_VALUE : (idle.e + idle.t); },
  stop: () => {
    console.log('[svc] idle', 'stop');
    idle.w.forEach(e => window.removeEventListener(e, idle.r));
    idle.s = true;
    return idle;
  },
  pause: () => { idle.p = true; return idle; },
  resume: () => { idle.p = false; return idle; },
  keepalive: (cb, ttl_sec = 1) => {
    if(!cb) { return; }
    console.log('[svc] idle.keepalive', 'start');
    idle.k = () => { if(idle.p || idle.e > new Date() - idle.t) { if(idle.s) { return; } cb(); idle.h.k = setTimeout(() => { idle.k(); }, ttl_sec * 1000); } };
    setTimeout(() => { idle.k(); }, ttl_sec * 1000);
    return idle;
  }
}

export default idle